module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("table of "), _c('i', [_vm._v("contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm02"
    }
  }, [_c('b', [_vm._v("acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_c('b', [_vm._v("foreword")]), _vm._v(" "), _c('i', [_vm._v("by Dr. Josh Axe")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('b', [_vm._v("PART ONE: commonsense evidence")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01"
    }
  }, [_c('span', {
    staticClass: "clr"
  }, [_vm._v("CHAPTER 1:")]), _vm._v(" "), _c('i', [_vm._v("you are not sinking")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap02"
    }
  }, [_c('span', {
    staticClass: "clr"
  }, [_vm._v("CHAPTER 2:")]), _vm._v(" "), _c('i', [_vm._v("you are not your past")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clr"
  }, [_vm._v("CHAPTER 3:")]), _vm._v(" "), _c('i', [_vm._v("inflammation is the devil")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clr"
  }, [_vm._v("CHAPTER 4:")]), _vm._v(" "), _c('i', [_vm._v("disease from sea to shining sea")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PART TWO: commonsense action")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clr"
  }, [_vm._v("CHAPTER 5:")]), _vm._v(" "), _c('i', [_vm._v("eat well")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clr"
  }, [_vm._v("CHAPTER 6:")]), _vm._v(" "), _c('i', [_vm._v("sleep well")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clr"
  }, [_vm._v("CHAPTER 7:")]), _vm._v(" "), _c('i', [_vm._v("move well")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clr"
  }, [_vm._v("CHAPTER 8:")]), _vm._v(" "), _c('i', [_vm._v("poop well")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clr"
  }, [_vm._v("CHAPTER 9:")]), _vm._v(" "), _c('i', [_vm._v("de-stress well")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "clr"
  }, [_vm._v("CHAPTER 10:")]), _vm._v(" "), _c('i', [_vm._v("commune well")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("endnotes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("about the author")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("resources")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d8ca3d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0